<label [class.sr-only]="!showLabel" [class.as-placeholder]="showLabel && !label?.length && !openAutocomplete && !disabled" 
[for]="name">{{placeholder | translate}}</label>

<div class="autocomplete-icon">
    <ng-content select="[nested-icon]"></ng-content>
</div>
<input #autocompleteInput type="text" class="form-control" [id]="name" [name]="name" [attr.tabindex]="index"
    [ngModel]="label" (ngModelChange)="onModelChange($event)"
    [placeholder]="!showLabel ? (placeholder | translate) : ''" [title]="placeholder | translate"
    (focus)="onFocus(value)" (blur)="onBlur($event)" [ngClass]="{
        'is-invalid': !!selectedOption[options?.colorKeys?.error], 
        'is-valid warning': !!selectedOption[options?.colorKeys?.warning]
    }" [ngStyle]="{'border-color': selectedOption | optionsListStyle : options?.styleFn }"
    [class]="selectedOption | optionsListStyle : options?.classFn" [disabled]="disabled" autocomplete="off"
    [attr.aria-invalid]="ariaInvalid">

<div *ngIf="openAutocomplete && (optionsList.length || inLoading)" id="autocomplete" [attr.tabindex]="index"
    class="autocomplete-container" aria-live="polite">
    <div class="autocomplete px-2">
        <div class="options-container" [class.active]="optionsList.length">
            <ng-container *ngFor="let option of optionsList; let i=index">
                <div [attr.tabindex]="index" (blur)="onBlur($event)" [id]="'autoOpt-' + i" class="options"
                    [ngStyle]="{'color': option | optionsListStyle : options?.styleFn }"
                    [class]="option | optionsListStyle : options?.classFn" [ngClass]="{
                            'error': !!option[options?.colorKeys?.error],
                            'warning': !!option[options?.colorKeys?.warning]
                        }" (mousedown)="selectOption(option)" (keydown.enter)="selectOption(option)">
                    <span>{{option | optionsListLabel : options?.labelKey : options?.outputKey}}</span>
                </div>
            </ng-container>
            <div *ngIf="inLoading && !optionsList?.length" class="loader-container">
                <aria-local-loader [inLoading]="true"></aria-local-loader>
            </div>
        </div>
    </div>
</div>